import React from 'react';

/**
 * BlogInternalLink - Styled link for internal navigation
 * Use for linking to other pages within the site
 * 
 * @param {Object} props
 * @param {string} props.href - Link destination
 * @param {React.ReactNode} props.children - Link text
 */
export const BlogInternalLink = ({ href, children }) => {
  return (
    <a 
      href={href}
      className="text-[#00E87A] hover:text-[#00FF88] hover:underline transition-colors duration-150"
      data-testid="blog-internal-link"
    >
      {children}
    </a>
  );
};

/**
 * BlogExternalLink - Styled link for external sites
 * Opens in new tab with proper security attributes
 * 
 * @param {Object} props
 * @param {string} props.href - Link destination
 * @param {React.ReactNode} props.children - Link text
 * @param {boolean} [props.showIcon=true] - Show external link icon
 */
export const BlogExternalLink = ({ href, children, showIcon = true }) => {
  return (
    <a 
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="text-[#00E87A] hover:text-[#00FF88] hover:underline transition-colors duration-150"
      data-testid="blog-external-link"
    >
      {children}
      {showIcon && (
        <span className="inline-block ml-1 text-xs">↗</span>
      )}
    </a>
  );
};

/**
 * BlogRelatedLink - Styled box for related content
 */
export const BlogRelatedLink = ({ href, label, title }) => {
  return (
    <div 
      className="mt-6 p-4 border border-gray-700 rounded-lg"
      data-testid="blog-related-link"
    >
      <p className="text-gray-200">
        <strong className="text-white">{label || 'Related'}:</strong>{' '}
        <a 
          href={href}
          className="text-[#00E87A] hover:text-[#00FF88] hover:underline transition-colors"
        >
          {title}
        </a>
      </p>
    </div>
  );
};

export default BlogInternalLink;
